import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";

function PrescribeInputText(props: any) {
  let myProps = {
    name: "",
    daily_prescribe_info: {},
    on_change_daily_prescribe_info: (inData: any) => { },
    onBlur: () => { },
    placeholder: "",
    is_able_write: true,
    ...props
  };
  let daily_prescribe_info = myProps.daily_prescribe_info;
  let val_str = daily_prescribe_info[myProps.name] || "";
  let is_able_write = myProps.is_able_write;

  return (
    <>
      {is_able_write ?
        <TextAreaComponent
          value={val_str}
          name={myProps.name}
          onChange={myProps.on_change_daily_prescribe_info}
          onBlur={myProps.onBlur}
          placeholder={myProps.placeholder}
          style={{ border: "0px" }}
        ></TextAreaComponent>
        :
        <div style={{ padding: "2px", background: "#ededed", minHeight: "25px", borderRadius: "8px" }}>
          <MultyLineTextView text={val_str}></MultyLineTextView>
        </div>
      }
    </>
  );
};
export default PrescribeInputText;